import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import {
  Home,
  Shop,
  Blog,
  Blogpage,
  Productpage,
  MyCart,
  Myorders,
  PlaceOrder,
  SearchPage,
  Profile,
  About,
  Contact,
} from "./pages";
import { Navbar, Footer, Toast, BottomNavigationbar } from "./components";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import AdminRoute from "./components/ProtectedRoute/AdminRoute";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminProducts from "./pages/Admin/AdminProducts";
import AdminOrders from "./pages/Admin/AdminOrders";
import AdminBlogs from "./pages/Admin/AdminBlogs";
import { useDispatch } from "react-redux";
import { getallProducts } from "./actions/productActions";
import { getUserInfo } from "./actions/userActions";
import Cookies from 'universal-cookie'
import { useLocation } from "react-router-dom";

const App = () => {
  const cookies = new Cookies()
  const dispatch = useDispatch();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  let tkn = cookies.get('tkn');

  useEffect(() => {
    const handleStatusChange = () => setIsOnline(navigator.onLine);
    window.addEventListener("online", handleStatusChange);
    window.addEventListener("offline", handleStatusChange);
    if (tkn === undefined) window.localStorage.clear();
    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, [isOnline]); // eslint-disable-line

  useEffect(() => {
    dispatch(getallProducts());
    if (tkn !== undefined) dispatch(getUserInfo());
  }, []); // eslint-disable-line

  return (
    <>
      <div className="displayBody">
        <Navbar />
        <BottomNavigationbar />
        <Toast />
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/mycart" element={<MyCart />} />
            <Route path="/myorders" element={<Myorders />} />
            <Route path="/placeorder" element={<PlaceOrder />} />
            <Route path="/myprofile" element={<Profile />} />
            <Route exact path="/blog/:id" element={<Blogpage />} />
            <Route exact path="/shop/:id" element={<Productpage />} />
            <Route path="/about" element={<About />} />
            <Route path="/search/:keyword" element={<SearchPage />} />
            <Route path="/contact" element={<Contact />} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>}>
              <Route path="products" element={<AdminProducts />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="blogs" element={<AdminBlogs />} />
            </Route>
          </Routes>
        </ErrorBoundary>
        {!isAdmin && <Footer />}
      </div>
    </>
  );
};

export default App;
